import React from "react";
import {GetText} from "../data/lang";


export const Footer = () => {

    let text = GetText();

    return (
            <div id='footer'>
                <div className='container text-center'>
                    <p>
                        &copy; 2008-{new Date().getFullYear()} MUK. {text ? text.Contact.footer : ""}
                    </p>
                </div>
            </div>
    )
}
